export default __webpack_public_path__ + "static/media/a001-05.295c097a.svg";